import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { SidebarStatuses } from '@atlassian/jira-shared-types/src/issue-sidebar.tsx';
import { useSidebarStore } from '@atlassian/jira-software-releases-issue-sidebar-use-sidebar-store/src/controllers/index.tsx';
import { RIGHT_SIDEBAR_WIDTH } from '@atlassian/jira-software-releases-version-detail-shared/src/common/constants.tsx';
import { SidebarContent } from './sidebar-content/SidebarContent.tsx';

export const IssueSidebar = (): React.JSX.Element | null => {
	const [sidebarState] = useSidebarStore();
	const isOpen = sidebarState.status !== SidebarStatuses.CLOSED;

	return isOpen ? (
		<IssueSidebarContainer>
			<SidebarContent />
		</IssueSidebarContainer>
	) : null;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IssueSidebarContainer = styled.div({
	height: '100%',
	position: 'relative',
	paddingTop: '0px',
	paddingRight: '0px',
	paddingBottom: token('space.200'),
	paddingLeft: '0px',
	boxSizing: 'border-box',

	backgroundColor: `${token('color.background.neutral.subtle')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${RIGHT_SIDEBAR_WIDTH}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	maxWidth: `${RIGHT_SIDEBAR_WIDTH}px`,
});
